module.exports = __webpack_public_path__ + "static/img/systen-set-active.3720171.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menu/systen-set-active.png
// module id = oJHC
// module chunks = 58